import React, { memo, SVGProps } from 'react'

export const PlusInCircle = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 20.6928C16.7798 20.6928 20.6697 16.7914 20.6697 11.9962C20.6697 7.20097 16.7798 3.29953 12 3.29953C7.22014 3.29953 3.33118 7.20001 3.33118 11.9962C3.33118 16.7923 7.22014 20.6928 12 20.6928ZM12 4.73953C15.9859 4.73953 19.2297 7.99489 19.2297 11.9962C19.2297 15.9975 15.9869 19.2528 12 19.2528C8.0131 19.2528 4.77118 15.9975 4.77118 11.9962C4.77118 7.99489 8.01406 4.73953 12 4.73953Z"
      fill="currentColor"
    />
    <path
      d="M8.30014 12.7152H11.28V15.696C11.28 16.0935 11.6025 16.416 12 16.416C12.3974 16.416 12.72 16.0935 12.72 15.696V12.7152H15.7008C16.0982 12.7152 16.4208 12.3926 16.4208 11.9952C16.4208 11.5978 16.0982 11.2752 15.7008 11.2752H12.72V8.29537C12.72 7.89793 12.3974 7.57537 12 7.57537C11.6025 7.57537 11.28 7.89793 11.28 8.29537V11.2752H8.30014C7.9027 11.2752 7.58014 11.5978 7.58014 11.9952C7.58014 12.3926 7.9027 12.7152 8.30014 12.7152Z"
      fill="currentColor"
    />
  </svg>
))
